// extracted by mini-css-extract-plugin
export default {"changePasswordBody":"ChangePasswordModal_changePasswordBody__gzn8Z"};